import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Pagination,
  Chip,
  CircularProgress,
} from "@mui/material";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Service.scss";
import "../../styles/App.scss";
import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";
import { VIEW_INVOICE } from "../../component/common/Routes/AppRoutes";
import { formatDateWithAmPm, columnFetcher } from "../../Style";
import ReusableTable from "../../component/ui/ReusableTable";
import { VENDOR_VIEW_INVOICE } from "../../component/common/Routes/VendorRoutes";
import { CUSTOMER_VIEW_INVOICE } from "../../component/common/Routes/CustomerRoutes";
import { useDispatch, useSelector } from "react-redux";
import { jsPDF } from "jspdf";
import Logo from "../../assets/Atithiseva-Logo-Final-1024x298.png";
import {
  fetchAllInvoicesRequest,
  fetchCustomerInvoicesRequest,
  fetchVendorInvoicesRequest,
  resetInvoiceDetails,
} from "../../redux/Invoice/InvoiceAction";
import nodata from "../../assets/nodata.jpg";
import axiosInstance from "../../redux/instance/AxiosInstance";

const ViewPaymentList = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const pageNumber = location.state?.page ?? 1;
  const searchNavigateQuery = location.state?.searchQuery ?? "";

  const [searchQuery, setSearchQuery] = useState(searchNavigateQuery ?? "");
  const user = useSelector((state) => state.auth.user);
  const payments = useSelector(
    user?.role === "Vendor"
      ? (state) => state?.Invoice?.vendorInvoice?.data
      : user?.role === "Customer"
        ? (state) => state?.Invoice?.customerInvoice?.data
        : (state) => state?.Invoice?.invoices?.data,
  );
  console.log("payments", payments);
  const paymentsConsolidateData = useSelector(
    user?.role === "Vendor"
      ? (state) => state?.Invoice?.vendorInvoice
      : user?.role === "Customer"
        ? (state) => state?.Invoice?.customerInvoice
        : (state) => state?.Invoice?.invoices,
  );

  const totalCount = useSelector((state) => {
    if (user?.role === "Vendor") {
      return state?.Invoice?.vendorInvoice?.totalRecords || 0;
    } else if (user?.role === "Customer") {
      return state?.Invoice?.customerInvoice?.totalRecords || 0;
    } else {
      return state?.Invoice?.invoices?.totalRecords || 0;
    }
  });

  const [searchColumn, setSearchColumn] = useState("");
  const [exportLoading, setExportLoading] = useState(false);
  const [page, setPage] = useState(pageNumber);
  const rowsPerPage = 10;
  const navigate = useNavigate();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const loading = useSelector((state) => {
    return state?.Invoice?.loading;
  });

  const searchTimerRef = useRef(null);
  const fetchData = (page, search = searchQuery, searchBy = searchColumn) => {
    const params = {};
    if (search) {
      params.pagination_required = true;
      params.pagesize = rowsPerPage;
      params.pageNo = page;
      params.search = search;

      if (searchBy && searchBy.trim() !== "") {
        params.search_by = searchBy;
      }
    } else {
      params.pagination_required = true;
      params.pagesize = rowsPerPage;
      params.pageNo = page;
    }

    if (user?.role === "Admin" || user?.role === "Staff") {
      dispatch(fetchAllInvoicesRequest(params));
    } else if (user?.role === "Customer") {
      dispatch(
        fetchCustomerInvoicesRequest({
          ...params,
          customer_id: user?.customer_id,
        }),
      );
    } else if (user?.role === "Vendor") {
      dispatch(
        fetchVendorInvoicesRequest({
          ...params,
          vendor_id: user?.vendor_id,
        }),
      );
    }
  };

  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

  const isVendor =
    payments?.BookingDetail?.booked_user_type === 2 &&
    (user?.role === "Admin" ||
      user?.role === "Staff" ||
      user?.role === "Vendor");

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(1);
  };

  const handleSearch = (query, column) => {
    setSearchQuery(query);
    if (column) {
      setSearchColumn(column);
    }

    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }

    searchTimerRef.current = setTimeout(() => {
      setPage(1);
      dispatch(resetInvoiceDetails());
      fetchData(1, query, column || searchColumn);
    }, 1000);
  };

  const isInitialLoad = React.useRef(true);
  useEffect(() => {
    if (isInitialLoad.current & !searchNavigateQuery) {
      dispatch(resetInvoiceDetails());
      fetchData(1, "", "");
      isInitialLoad.current = false;
    } else if (!searchQuery) {
      fetchData(page, searchQuery, searchColumn);
    } else {
      fetchData(page, searchQuery, searchColumn);
    }
  }, [page, dispatch]);

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);
  const handleDownloadPDF = (paymentDetails) => {
    const isVendor =
      paymentDetails?.BookingDetail?.booked_user_type === 2 &&
      (user?.role === "Admin" ||
        user?.role === "Staff" ||
        user?.role === "Vendor");
    const orderSource = isVendor
      ? paymentDetails?.vendorBookLogs?.[0]
      : paymentDetails?.Order;
    const doc = new jsPDF();

    const primaryColor = [237, 125, 49];
    const secondaryColor = [247, 150, 70];
    const textColor = [50, 50, 50];
    const lightGray = [245, 245, 245];
    const lightOrange = [252, 235, 218];

    const rupeePrefix = "Rs.";
    const editBookingCharge = paymentDetails?.totalPenaltyCharge || 0;
    const isEditBooking = editBookingCharge > 0;

    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 40, "F");

    doc.setFillColor(...secondaryColor);
    doc.rect(0, 52, 210, 1, "F");

    if (Logo) {
      doc.addImage(Logo, "PNG", 160, 10, 35, 15);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(...primaryColor);
    doc.text("INVOICE", 15, 20);

    doc.setFontSize(10);
    doc.setTextColor(...textColor);
    doc.text(
      `PNR NUMBER : ${paymentDetails?.pnr_number || "INV-2024001"}`,
      15,
      27,
    );
    doc.text(
      `BOOKING NUMBER : ${paymentDetails?.booking_serial_no || "INV-2024001"}`,
      15,
      34,
    );
    doc.text(`Date: ${formatDateWithAmPm(paymentDetails?.created_at)}`, 15, 40);
    doc.text(
      `Payment Method : ${
        paymentDetails?.paymentLogs?.[0]?.payment_logs?.payments?.[0]?.method ||
        "UPI"
      }`,
      15,
      47,
    );
    doc.setFontSize(11);
    doc.setTextColor(...textColor);
    doc.setFont("helvetica", "bold");
    doc.text("FROM:", 15, 60);
    doc.setFont("helvetica", "normal");
    doc.text("Atithiseva Private Limited", 15, 67);
    doc.text("158, 1st Floor, Tower II, Rayala towers,Anna Salai", 15, 73);
    doc.text("Chennai, TamilNadu,  600002", 15, 80);
    doc.text("care@atithiairportseva.com", 15, 87);

    doc.setFont("helvetica", "bold");
    doc.text("BILLED TO:", 115, 60);

    const billingDetails = [
      paymentDetails?.Customer?.full_name ||
        paymentDetails?.BillingAddress?.name ||
        "Customer Name",
      [
        `${paymentDetails?.BillingAddress?.address1} ${paymentDetails?.BillingAddress?.address2}` ||
          "Address Line 1",
        paymentDetails?.city_name || "City",
        paymentDetails?.state_name || "State",
        paymentDetails?.country_name || "India",
      ]
        .filter(Boolean)
        .join(", "),
      [paymentDetails?.BillingAddress?.pincode || "000000"]
        .filter(Boolean)
        .join(", "),
      paymentDetails?.Customer?.email ||
        paymentDetails?.BillingAddress?.email ||
        "customer@email.com",
    ];

    let currentY = 67;
    billingDetails.forEach((detail) => {
      const textLines = doc.splitTextToSize(detail, 75);
      textLines.forEach((line) => {
        doc.setFont("helvetica", "normal");
        doc.text(line, 115, currentY, {
          maxWidth: 75,
        });
        currentY += 6;
      });
    });

    doc.setFillColor(...lightOrange);
    doc.roundedRect(12, currentY + 10, 180, 10, 1, 1, "F");
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...textColor);

    const columnWidths = {
      airport: isEditBooking ? 30 : 35,
      service: isEditBooking ? 50 : 45,
      passengers: 30,
      total: 30,
    };

    const columnPositions = {
      airport: 15,
      // service: isEditBooking ? 65 : 70,
      service: 70,
      passengers: 125,
      total: 180,
    };
    doc.text("Place Of Supply", columnPositions.airport + 10, currentY + 17);

    doc.text("Service", columnPositions.service - 10, currentY + 17);

    doc.text("Passengers", columnPositions.passengers - 10, currentY + 17);

    doc.text("Price", columnPositions.total - 10, currentY + 17, {
      align: "right",
    });

    doc.setFont("helvetica", "normal");
    let y = currentY + 27;
    const servicePrice = isVendor
      ? paymentDetails?.vendorBookLogs?.[0]?.price
      : paymentDetails?.Order?.price;
    console.log("servicePrice", servicePrice);
    const items = [
      {
        airport: paymentDetails?.Airport?.name || "Airport",
        services: paymentDetails?.Service?.services || "Service",
        passengers: paymentDetails?.BookingDetail?.total_passengers || 0,
        total: servicePrice || 0,
      },
    ];

    const formatCurrency = (amount) => {
      return `${rupeePrefix} ${parseFloat(amount).toFixed(2)}`;
    };

    items.forEach((item, index) => {
      if (index % 2 === 1) {
        doc.setFillColor(...lightGray);
        doc.rect(15, y - 5, 180, 10, "F");
      }
      const airportText = doc.splitTextToSize(
        item.airport,
        columnWidths.airport,
      );
      const serviceText = doc.splitTextToSize(
        item.services,
        columnWidths.service,
      );

      const lineHeight = 7;
      const airportLines = airportText.length;
      const serviceLines = serviceText.length;
      const maxLines = Math.max(airportLines, serviceLines, 1);
      const rowHeight = maxLines * lineHeight;
      if (maxLines > 1 && index % 2 === 1) {
        doc.setFillColor(...lightGray);
        doc.rect(15, y - 5, 180, rowHeight, "F");
      }

      doc.text(airportText, columnPositions.airport + 10, y);

      doc.text(serviceText, columnPositions.service - 10, y);

      doc.text(item.passengers.toString(), columnPositions.passengers - 10, y);
      doc.text(formatCurrency(item.total), columnPositions.total - 19, y);
    });

    y += 15;
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(15, y, 195, y);
    y += 10;

    const subtotal = isVendor
      ? paymentDetails?.vendorBookLogs?.[0]?.sub_total
      : paymentDetails?.Order?.sub_total || 0;

    // const discountPercentage = paymentDetails.Order?.discount || 0;

    const sgstRate = ((orderSource?.sgst / subtotal) * 100 || 0).toFixed(0);
    const cgstRate = ((orderSource?.cgst / subtotal) * 100 || 0).toFixed(0);
    const taxRate =
      ((paymentDetails?.Order?.tax / subtotal) * 100).toFixed(0) || 0;

    const cgstAmount = subtotal * (cgstRate / 100) || 0;
    const sgstAmount = subtotal * (sgstRate / 100) || 0;
    const taxAmount = paymentDetails?.Order?.tax || 0;
    const vendorCommission = orderSource?.vendor_commision || 0;
    const instantBookingCharge = paymentDetails?.Order?.additional_payment || 0;
    const grandTotal = isVendor
      ? paymentDetails?.vendorBookLogs?.[0]?.total
      : paymentDetails?.Order?.total;
    const adultFamilyMember = paymentDetails?.bookingFamilies?.filter(
      (adult) => {
        return adult?.familyMember?.age >= 12;
      },
    );
    const childFamilyMember = paymentDetails?.bookingFamilies?.filter(
      (child) => {
        return child?.familyMember?.age >= 2 && child?.familyMember?.age < 12;
      },
    );
    const infantFamilyMember = paymentDetails?.bookingFamilies?.filter(
      (infant) => {
        return infant?.familyMember?.age < 2;
      },
    );

    const adultDiscount = adultFamilyMember?.[0]?.familyMember?.discount || 0;
    const childDiscount = childFamilyMember?.[0]?.familyMember?.discount || 0;
    const infantDiscount = infantFamilyMember?.[0]?.familyMember?.discount || 0;

    const bankDetailsX = 15;
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("Bank Details", bankDetailsX, y);
    doc.setFont("helvetica", "normal");
    doc.text("Payable To : ATITHISEVA PRIVATE LIMITED", bankDetailsX, y + 6);
    doc.text("Bank Name : HDFC BANK", bankDetailsX, y + 12);
    doc.text("Branch : MAHALINGAPURAM", bankDetailsX, y + 18);
    doc.text("A/c NO : 50200076092115", bankDetailsX, y + 24);
    doc.text("IFSC CODE : HDFC0001867", bankDetailsX, y + 30);
    doc.text("CIN : U63030TN2022PTC155334", bankDetailsX, y + 36);
    doc.text("GSTIN : 33AAXCA6365L1ZZ", bankDetailsX, y + 42);

    const totalsX = 110;
    const totalsAlignX = 185;

    if (isVendor && vendorCommission > 0) {
      y += 7;
      doc.text(`Vendor Commission`, totalsX, y);
      doc.text(`-${formatCurrency(vendorCommission)}`, totalsAlignX, y, {
        align: "right",
      });
    }

    y += 7;
    doc.text(`Sub Total`, totalsX, y);
    doc.text(`${formatCurrency(subtotal)}`, totalsAlignX, y, {
      align: "right",
    });

    if (instantBookingCharge > 0) {
      y += 7;
      doc.text(`Instant Booking Charge`, totalsX, y);
      doc.text(`${formatCurrency(instantBookingCharge)}`, totalsAlignX, y, {
        align: "right",
      });
    }

    if (isEditBooking) {
      y += 7;
      doc.text(`Amendment Charge (Include taxex)`, totalsX, y);
      doc.text(formatCurrency(editBookingCharge), totalsAlignX, y, {
        align: "right",
      });
    }

    if (cgstRate > 0) {
      y += 7;
      doc.text(`CGST (${cgstRate}%)`, totalsX, y);
      doc.text(formatCurrency(cgstAmount), totalsAlignX, y, {
        align: "right",
      });
    }

    if (sgstRate > 0) {
      y += 7;
      doc.text(`SGST (${sgstRate}%)`, totalsX, y);
      doc.text(formatCurrency(sgstAmount), totalsAlignX, y, {
        align: "right",
      });
    }

    if (taxRate > 0) {
      y += 7;
      doc.text(`IGST (${taxRate}%)`, totalsX, y);
      doc.text(formatCurrency(taxAmount), totalsAlignX, y, {
        align: "right",
      });
    }

    const totalSectionY = isEditBooking ? y + 20 : y + 12;

    doc.setFillColor(...primaryColor);
    doc.roundedRect(totalsX, totalSectionY - 5, 75, 12, 2, 2, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL", totalsX + 10, totalSectionY + 2);
    doc.setFontSize(11);
    doc.text(formatCurrency(grandTotal), 182, totalSectionY + 2, {
      align: "right",
    });

    const termsY = totalSectionY + 30;
    doc.setTextColor(...textColor);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("TERMS & CONDITIONS", 15, termsY);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "1. In case of any disputes the same must be brought into our notice in writing.",
      15,
      termsY + 7,
    );
    doc.text(
      "2. All bills must be paid within 7 days of billing or within contracted payment period to avoid levy of 18% interest.",
      15,
      termsY + 14,
    );
    doc.text(
      "3. All disputes are subject to invoice and does not require a signature.",
      15,
      termsY + 21,
    );
    doc.text(
      "This is a computer generated invoice and does not require a signature.",
      15,
      termsY + 28,
    );

    doc.setFontSize(9);
    doc.setTextColor(...textColor);
    doc.setFont("helvetica", "bold");
    doc.text("For ATITHISEVA PRIVATE LIMITED", 140, totalSectionY + 55);
    doc.text("Authorised Signatory", 150, totalSectionY + 62);

    const footerStartY = termsY + 45;

    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(15, footerStartY, 195, footerStartY);

    const contactY = footerStartY + 10;
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    doc.text(
      "accounts@atithiairportseva.com | care@atithiairportseva.com | +91 99622 03022",
      105,
      contactY,
      { align: "center" },
    );

    doc.save(
      `Invoice-${
        paymentDetails.booking_serial_no ||
        paymentDetails.pnr_number ||
        "INV-2024001"
      }.pdf`,
    );
  };

  const handleExport = () => {
    setExportLoading(true);
    const params = {
      pagination_required: false,
    };

    if (searchQuery) {
      params.search = searchQuery;

      if (searchColumn && searchColumn.trim() !== "") {
        params.search_by = searchColumn;
      }
    }

    let apiCall;

    if (user?.role === "Admin" || user?.role === "Staff") {
      apiCall = axiosInstance.get(`/reports/getbookingservicereports`, {
        params,
      });
    } else if (user?.role === "Customer") {
      apiCall = axiosInstance.get(`/reports/bookinggetbycustomer`, {
        params: {
          ...params,
          customer_id: user?.customer_id || "",
          vendor_id: "",
        },
      });
    } else if (user?.role === "Vendor") {
      apiCall = axiosInstance.get(`/reports/bookinggetbycustomer`, {
        params: {
          ...params,
          vendor_id: user?.vendor_id || "",
        },
      });
    } else {
      console.error("Unknown user role, cannot export.");
      return;
    }

    const escapeCSVField = (field) => {
      if (field == null) return "";
      const value = String(field);
      if (/[,"\n]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    };

    apiCall
      .then((response) => {
        const allPaymentsData = response?.data?.data || [];
        console.log("allPaymentsData", allPaymentsData);
        const csvHeaders = [
          "Payment Id",
          "Booking Id",
          "Payment Date And Time",
          "Gross Total",
          "Vendor Discount Amount",
          "Sub Total",
          "CGST",
          "SGST",
          "Amendment Charge",
          "Total",
          "Payment Status",
        ];

        const csvRows = allPaymentsData.map((payment) => [
          escapeCSVField(payment?.pnr_number),
          escapeCSVField(payment?.booking_serial_no),
          escapeCSVField(formatDateWithAmPm(payment?.created_at)),
          escapeCSVField(
            payment.vendorBookLogs?.length > 0 &&
              (user?.role === "Admin" ||
                user?.role === "Staff" ||
                user?.role === "Vendor")
              ? payment.vendorBookLogs[0]?.price
              : payment?.Order?.sub_total,
          ),
          escapeCSVField(
            payment.vendorBookLogs?.length > 0 &&
              (user?.role === "Admin" ||
                user?.role === "Staff" ||
                user?.role === "Vendor")
              ? payment.vendorBookLogs[0]?.vendor_commision
              : 0,
          ),
          escapeCSVField(
            payment.vendorBookLogs?.length > 0 &&
              (user?.role === "Admin" ||
                user?.role === "Staff" ||
                user?.role === "Vendor")
              ? payment.vendorBookLogs[0]?.sub_total
              : payment?.Order?.sub_total,
          ),
          escapeCSVField(
            payment?.vendorBookLogs?.[0]?.cgst ?? payment?.Order?.cgst ?? 0,
          ),
          escapeCSVField(
            payment?.vendorBookLogs?.[0]?.sgst ?? payment?.Order?.sgst ?? 0,
          ),
          escapeCSVField(payment?.totalPenaltyCharge ?? 0),
          escapeCSVField(
            payment.vendorBookLogs?.length > 0 &&
              (user?.role === "Admin" ||
                user?.role === "Staff" ||
                user?.role === "Vendor")
              ? payment.vendorBookLogs[0]?.total
              : payment?.Order?.total,
          ),
          escapeCSVField(
            payment?.payment_status === 1
              ? "Completed"
              : payment?.payment_status === 2
                ? "Pending"
                : "Rejected",
          ),
        ]);

        const csvContent = [csvHeaders, ...csvRows]
          .map((row) => row.join(","))
          .join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        saveAs(blob, "payments.csv");
        setExportLoading(false);
      })
      .catch((error) => {
        console.error("Export error:", error);
        setExportLoading(false);
      });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleView = (payment) => {
    let viewRoute;

    if (user.role === "Admin" || user.role === "Staff") {
      viewRoute = VIEW_INVOICE;
    } else if (user.role === "Vendor") {
      viewRoute = VENDOR_VIEW_INVOICE;
    } else if (user.role === "Customer") {
      viewRoute = CUSTOMER_VIEW_INVOICE;
    }
    dispatch(resetInvoiceDetails());
    navigate(viewRoute, {
      state: {
        invoiceId: payment?.BookingDetail?.booking_id,
        page: page,
        searchQuery: searchQuery,
      },
    });
  };

  const columns = [
    { field: "pnr_number", header: "Payment Id" },
    { field: "booking_serial_no", header: "Booking Id" },
    {
      field: "Customer.full_name",
      header: "Customer Name",
      render: (value, row) => {
        return row.Customer?.full_name || "-";
      },
    },
    {
      field: "created_at",
      header: "Payment Date",
      render: (value) => formatDateWithAmPm(value),
    },
    {
      field: "gross_total",
      header: "Gross Total",
      render: (value, row) => {
        const grossTotal =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.vendorBookLogs[0]?.price
            : row?.Order?.sub_total;
        return currencyFormatter.format(grossTotal || 0);
      },
    },
    {
      field: "vendor_discount",
      header: "Vendor Discount Amount",
      render: (value, row) => {
        const discount =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.vendorBookLogs[0]?.vendor_commision
            : 0;
        return currencyFormatter.format(discount || 0);
      },
    },
    {
      field: "price",
      header: "Sub Total",
      render: (value, row) => {
        const price =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.vendorBookLogs[0]?.sub_total
            : row?.Order?.sub_total;
        return currencyFormatter.format(price || 0);
      },
    },
    {
      field: "cgst",
      header: "CGST",

      render: (value, row) => {
        const cgst =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.vendorBookLogs[0]?.cgst
            : row.Order?.cgst;
        return currencyFormatter.format(cgst || 0);
      },
    },
    {
      field: "sgst",
      header: "SGST",
      render: (value, row) => {
        const sgst =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.vendorBookLogs[0]?.sgst
            : row.Order?.sgst;
        return currencyFormatter.format(sgst || 0);
      },
    },
    {
      field: "tax",
      header: "IGST",
      render: (value, row) => {
        const tax =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row.Order?.tax
            : row.Order?.tax;
        return currencyFormatter.format(tax || 0);
      },
    },
    {
      field: "totalPenaltyCharge",
      header: "Amendment Charge",
      render: (value, row) => {
        return currencyFormatter.format(row?.totalPenaltyCharge || 0);
      },
    },

    {
      field: "total_amount",
      header: "Total",
      render: (value, row) => {
        console.log("row", row);
        const total =
          row.vendorBookLogs?.length > 0 &&
          (user?.role === "Admin" ||
            user?.role === "Staff" ||
            user?.role === "Vendor")
            ? row?.vendorBookLogs[0]?.total
            : row?.Order?.total;
        return currencyFormatter.format(total || 0);
      },
    },
    {
      field: "payment_status",
      header: "Payment Status",
      render: (value, row) => {
        return (
          <Chip
            label={
              value === 1
                ? "Completed"
                : value === 0 && row?.booked_type === 2
                  ? "Free (Complementary)"
                  : value === 0
                    ? "Pending"
                    : value === 2
                      ? "Failed"
                      : value === 3
                        ? "Refunded"
                        : "Aborted"
            }
            color={
              value === 1
                ? "success"
                : value === 0 && row?.booked_type === 2
                  ? "success"
                  : value === 2
                    ? "error"
                    : value === 3
                      ? "success"
                      : value === 0
                        ? "warning"
                        : "error"
            }
            size="small"
          />
        );
      },
    },
  ];

  const filterColumns = [
    { value: "pnr_number", label: "Payment Id" },
    { value: "booking_serial_no", label: "Booking Id" },
    { value: "created_at", label: "Payment Date" },
  ];

  return (
    <Box className="container">
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <SearchAndButtonTab
                title={"Invoices"}
                columns={filterColumns}
                searchColumn={searchColumn}
                setSearchColumn={setSearchColumn}
                searchQuery={searchQuery}
                setSearchQuery={handleSearch}
                handleExport={handleExport}
                hideSearchColumnSelector={true}
                exportLoading={exportLoading}
              />
              {loading ? (
                <Box textAlign="center" py={5}>
                  <CircularProgress />
                </Box>
              ) : payments?.length > 0 ? (
                <>
                  <ReusableTable
                    data={payments}
                    columns={columns}
                    headers={columns}
                    paginatedData={payments}
                    handleView={handleView}
                    pdfData={payments}
                    handleDownloadPDF={handleDownloadPDF}
                    onSort={handleSort}
                    order={order}
                    orderBy={orderBy}
                    loading={loading}
                  />

                  <Box mt={2} display="flex" justifyContent="end">
                    <Pagination
                      count={Math.ceil(totalCount / rowsPerPage)}
                      page={page}
                      onChange={handlePageChange}
                      color="primary"
                    />
                  </Box>
                </>
              ) : (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%"
                  py={5}
                >
                  <img
                    src={nodata}
                    alt="No Data"
                    style={{
                      maxWidth: "300px",
                      maxHeight: "300px",
                    }}
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViewPaymentList;
